module.exports = __webpack_public_path__ + "img/MDL.83168fc5.svg";